<template>
    <div id="app">
        <router-view/>
        <loading-view :show="loading"></loading-view>
    </div>
</template>

<script>
import { getAccid,getUserAllInfo } from '@/api/app';
import loadingView from "@/components/loadView";

export default {
    computed: {
        loading() {
            return this.$store.state.httploading;
        }
    },
    components: {
        "loading-view": loadingView
    },
    mounted(){
        if(this.$route.query.debugger){
            var debugconsole = new vconsole();
		};
    }
};
</script>

<style lang="scss">
@import "./static/style/reset.scss";
@import url('//at.alicdn.com/t/font_1192702_w2p42p8a2dj.css');
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100%;
}
#app.hasNav {
    padding-bottom: 50px;
}
html,
#app,
body {
    min-height: 100%;
    height: 100%;
}
body {
    font-size: 1.2rem;
}
.mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
}
.el-message {
	min-width: 0px;
	max-width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/app.vue